// Auto-extraction prompt — runs silently after every JARVIS chat message.
// Pulls rules, behaviors, patterns, and daily lessons from conversations.
// Returns strict JSON only — no explanation text.

export const buildExtractionPrompt = (userMessage, jarvisReply) => `
Analyze this XAU/USD trading conversation and extract all learnable data.

USER SAID:
"${userMessage}"

JARVIS REPLIED:
"${jarvisReply}"

Extract everything useful and return ONLY valid JSON (no markdown, no explanation, no text outside the JSON):

{
  "hasNewRule": false,
  "rule": {
    "title": "Short descriptive title (e.g. '0.618 London BUY')",
    "fib_level": "0.382 or 0.500 or 0.618 or 0.705 or 0.786 or null",
    "ict_concept": "OB or FVG or Liquidity or BOS or CHoCH or OTE or AMD or null",
    "condition": "Full description of when this rule applies",
    "action": "BUY or SELL or WAIT",
    "session": "London or NY or Any",
    "htf_bias": "Bullish or Bearish or Any",
    "sl_method": "Description of stop loss placement or null",
    "tp_method": "Description of take profit target or null",
    "notes": "Any extra context",
    "source": "auto_extracted"
  },
  "hasNewBehavior": false,
  "behavior": {
    "title": "Short behavior title (e.g. 'Tuesday London power move')",
    "category": "session or ict or news or time or candle or dxy or general",
    "description": "What this behavior means",
    "conditions": ["condition1", "condition2"],
    "typical_outcome": "What usually happens after this behavior",
    "learned_from": "Chat discussion"
  },
  "hasNewPattern": false,
  "pattern": {
    "title": "Pattern name (e.g. '0.618 + OB + London confluence')",
    "description": "What this pattern is and why it works",
    "conditions": ["element1", "element2", "element3"],
    "category": "entry or exit or avoidance or structure"
  },
  "hasDailyLesson": false,
  "dailyLesson": {
    "market_behavior": "How the market behaved (directional, ranging, volatile, etc.)",
    "key_levels": "Key price levels mentioned",
    "ict_observations": "Any ICT/SMC observations (OB tested, liquidity swept, etc.)",
    "patterns_observed": "Patterns seen in today's market",
    "what_worked": "What setup or strategy worked",
    "what_failed": "What failed or should be avoided",
    "notes": "Other notable observations"
  },
  "hasICTUpdate": false,
  "ictUpdate": {
    "type": "order_block or fvg or liquidity or market_structure",
    "action": "add or update_status",
    "data": {}
  }
}

RULES FOR EXTRACTION:
- Only set hasNewRule to true if a CLEAR trading rule is discussed (level + condition + action)
- Only set hasNewBehavior to true if a REPEATABLE market behavior is mentioned
- Only set hasNewPattern to true if a combination of factors forming a pattern is discussed
- Only set hasDailyLesson to true if the user is describing today's market action
- Set all other has* fields to false if there is nothing to extract for that type
- If unsure, set the has* field to false rather than guessing
- The JSON must be valid and parseable — no trailing commas, no comments inside JSON
`;
